export default [{
	path: 'customers',
	name: 'Customer',
	component: resolve => require(['@/views/Customer/index.vue'], resolve),
	meta: {
		title: '客户（4S）',
		name: 'Customer',
	}
},{
	path: 'customer_info',
	name: 'CustomerInfo',
	component: resolve => require(['@/views/CustomerInfo/index.vue'], resolve),
	meta: {
		title: '客户详情',
		name: 'CustomerInfo',
		isShow:true
	}
}
]


// WEBPACK FOOTER //
// ./src/router/modules/customer.route.js